export const isMac = () =>
  navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
  navigator.userAgent.toUpperCase().indexOf("MAC") >= 0;
